export const getModalStatus = state => state.modalStatus;
